import { api, ApiError } from '@/lib/api';
import type { MedicalRecord, RecordPetOption, UpsertRecordInput } from './types';

/** The visit's record, or null if the vet hasn't started one yet (404). */
export async function fetch_record(booking_id: string): Promise<MedicalRecord | null> {
  try {
    const res = await api.get<MedicalRecord>(`/vendor/bookings/${booking_id}/record`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}

/** The booking owner's pets — only needed when the visit was booked without one. */
export async function fetch_pet_options(booking_id: string): Promise<RecordPetOption[]> {
  const res = await api.get<RecordPetOption[]>(`/vendor/bookings/${booking_id}/record/pet-options`);
  return res.data;
}

export async function create_record(booking_id: string, input: UpsertRecordInput): Promise<MedicalRecord> {
  const res = await api.post<MedicalRecord>(`/vendor/bookings/${booking_id}/record`, input);
  return res.data;
}

export async function update_record(booking_id: string, input: UpsertRecordInput): Promise<MedicalRecord> {
  const res = await api.patch<MedicalRecord>(`/vendor/bookings/${booking_id}/record`, input);
  return res.data;
}

export async function finalize_record(booking_id: string): Promise<MedicalRecord> {
  const res = await api.post<MedicalRecord>(`/vendor/bookings/${booking_id}/record/finalize`);
  return res.data;
}

export async function upload_prescription_doc(booking_id: string, file: File): Promise<MedicalRecord> {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post<MedicalRecord>(`/vendor/bookings/${booking_id}/record/prescription-doc`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function delete_prescription_doc(booking_id: string, image_id: string): Promise<MedicalRecord> {
  const res = await api.delete<MedicalRecord>(`/vendor/bookings/${booking_id}/record/prescription-doc/${image_id}`);
  return res.data;
}
